import { ChevronDown } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { OptionType } from '@/modules/common/types';

interface FilterMultiSelectProps {
  options: OptionType[];
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
}

export const FilterMultiSelect = ({
  options,
  label,
  values,
  onChange,
}: FilterMultiSelectProps) => {
  const toggleValue = (val: string) => {
    if (values.includes(val)) {
      onChange(values.filter((v) => v !== val));
    } else {
      onChange([...values, val]);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="px-3 relative flex items-center justify-between h-[37px] rounded-lg border border-gray-700 bg-black text-white shadow-sm hover:bg-zinc-900">
          <span className="flex items-center space-x-1 [&>span]:capitalize [&>span]:truncate [&>span:last-child]:pr-4">
            <span className="text-zinc-500 text-sm">{label}: </span>
            {values.length > 0 && values.length < options.length ? (
              <span className="text-sm text-zinc-50 data-[placeholder]:text-zinc-50 data-[placeholder]:capitalize">
                {values
                  .map(
                    (val) => options.find((opt) => opt.id === val)?.value ?? val
                  )
                  .join(', ')}
              </span>
            ) : (
              <span className="text-zinc-50 data-[placeholder]:text-zinc-50">
                All
              </span>
            )}
            <ChevronDown size={16} />
          </span>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[var(--radix-dropdown-menu-trigger-width)] bg-black text-white border border-zinc-800 rounded-lg p-1"
        align="start"
      >
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.id}
            checked={values.includes(option.id)}
            onCheckedChange={() => toggleValue(option.id)}
            className="capitalize focus:bg-zinc-800 focus:text-white"
          >
            {option.value}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
